// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__39_f5","dragIcon":"Choice_dragIcon__1drax","left":"Choice_left__KbHVH","input":"Choice_input__3AvXE"};